import CampaignReportPageHeadline from './CampaignReportPageHeadline';

export default CampaignReportPageHeadline;
